import router from '@app/router';
import { RouteName } from '@app/router/constants/RouteName';

export function ensureUserIsOnBetSlipRoute(currentRouteName: string): void {
    if (!betSlipRoutes.includes(currentRouteName)) {
        router.push({
            name: RouteName.App.Home,
        });
    }
}

const betSlipRoutes: string[] = [
    RouteName.Sport.PrematchOffer,
    RouteName.Sport.Competition,
    RouteName.App.Home,
];
